/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Simplified address for borrower contract context
 * @export
 * @interface BorrowerContractAddressDto
 */
export interface BorrowerContractAddressDto {
    /**
     * Address line 1
     * @type {string}
     * @memberof BorrowerContractAddressDto
     */
    line1?: string | null;
    /**
     * Address line 2
     * @type {string}
     * @memberof BorrowerContractAddressDto
     */
    line2?: string | null;
    /**
     * Postal code
     * @type {string}
     * @memberof BorrowerContractAddressDto
     */
    postalCode?: string | null;
    /**
     * City name
     * @type {string}
     * @memberof BorrowerContractAddressDto
     */
    city?: string | null;
    /**
     * Country name
     * @type {string}
     * @memberof BorrowerContractAddressDto
     */
    country?: string | null;
}

/**
 * Check if a given object implements the BorrowerContractAddressDto interface.
 */
export function instanceOfBorrowerContractAddressDto(value: object): value is BorrowerContractAddressDto {
    return true;
}

export function BorrowerContractAddressDtoFromJSON(json: any): BorrowerContractAddressDto {
    return BorrowerContractAddressDtoFromJSONTyped(json, false);
}

export function BorrowerContractAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerContractAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function BorrowerContractAddressDtoToJSON(json: any): BorrowerContractAddressDto {
    return BorrowerContractAddressDtoToJSONTyped(json, false);
}

export function BorrowerContractAddressDtoToJSONTyped(value?: BorrowerContractAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'postalCode': value['postalCode'],
        'city': value['city'],
        'country': value['country'],
    };
}

